import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const DSO_CODES = new Set([
  '911', '916', '917', '903', '914', '905', '904', '913',
  '312', '302', '301', '303', '882', '315', '309', '310', '308', '314', '311', '307', '305', '304', '306', '888', '313',
  '413', '402', '404', '401', '886', '411', '405', '408', '407', '412', '406', '409', '410', '883',
  '280', '283', '281', '284', '285', '286', '282',
  '217', '219', '211', '887', '220', '218', '213', '208', '212', '209', '215', '881', '210', '255', '216', '207', '205', '201', '203', '901',
  '224', '225', '221', '223', '226', '222', '230',
  '270', '271', '272', '891', '274', '273',
  '249', '247', '245', '227', '228', '246', '229', '252', '250', '243', '235', '239', '233', '231', '244', '236', '240',
  '519', '515', '517', '511', '512', '516', '518', '521',
  '559', '580', '555', '547', '885', '558', '556', '592', '560', '590', '591', '592', '549', '587', '557', '548',
  '527', '525', '509', '523', '889', '510', '522', '524', '528', '542',
  '533', '544', '539', '540', '535', '534', '536', '545', '543', '541',
  '577', '553', '563', '561', '552', '564', '583', '554', '581', '573', '565', '571', '569', '566', '890', '574', '567', '575', '570', '572',
  '531', '505', '501', '503', '884', '520', '506', '705', '702', '701', '708', '707', '704', '703', '706', '123', '111', '555'
]);

// Pola 1: Referensi: 917-G917251020143219035LQT
const REF_REGEX = /referensi\s*[:：]\s*\(?\s*(\d{3})-G/i;
// Pola 2: standalone 212-G21225091215154S509PVV (Faktur Pajak)
const STANDALONE_REGEX = /(\d{3})-G\S+/g;

/**
 * Get current date as dd-mm-yyyy string
 */
function getDateString() {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  return `${day}-${month}-${year}`;
}

async function extractText(arrayBuffer) {
  try {
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let fullText = '';
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      const pageText = content.items.map((item) => item.str).join(' ');
      fullText += pageText + '\n';
    }
    return fullText;
  } catch (e) {
    return '';
  }
}

export async function processPdf(file) {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const text = await extractText(arrayBuffer);
    let fullCode = null;

    const m1 = REF_REGEX.exec(text);
    if (m1 && DSO_CODES.has(m1[1])) {
      fullCode = text.substring(m1.index).match(/(\d{3}-G\S+)/)?.[1] || m1[1];
    }

    if (!fullCode) {
      STANDALONE_REGEX.lastIndex = 0;
      let m2;
      while ((m2 = STANDALONE_REGEX.exec(text)) !== null) {
        if (DSO_CODES.has(m2[1])) {
          fullCode = m2[0];
          break;
        }
      }
    }

    if (!fullCode) {
      return {
        success: false,
        originalName: file.name,
        message: `Kode Cabang tidak ditemukan dalam ${file.name}`,
      };
    }

    const ext = file.name.substring(file.name.lastIndexOf('.'));
    const dateStr = getDateString();
    const newFileName = `${fullCode}_${dateStr}${ext}`;

    return {
      success: true,
      originalName: file.name,
      newFileName,
      message: `Berhasil memproses ${file.name}`,
      blob: file,
    };
  } catch (e) {
    return {
      success: false,
      originalName: file.name,
      message: `Error memproses ${file.name}: ${e.message}`,
    };
  }
}
